import { useToggleState } from '@cian/react-utils';
import { useDeviceType } from '@cian/ui-kit';
import { AccrodionItem } from 'shared/components/AccordionItem';
import { TPoints } from 'shared/types/points';

type AccordionContainerProps = TPoints;

export const AccordionItemContainer: React.FC<AccordionContainerProps> = props => {
  const { state: openDescr, toggle: toggleOpenDescr } = useToggleState(false);

  const device = useDeviceType();

  const isNotDesktop = device !== 'desktop';

  return (
    <AccrodionItem {...props} isNotDesktop={isNotDesktop} onToggleOpenDescr={toggleOpenDescr} isOpenDescr={openDescr} />
  );
};
